var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeedometerKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5,12h-1c0-4.411,3.589-8,8-8,1.295,0,2.514.316,3.597.864l-.753.745c-.87-.389-1.831-.61-2.844-.61-3.859,0-7,3.14-7,7Zm7,2c-1.103,0-2-.897-2-2s.897-2,2-2c.358,0,.689.102.98.267l4.322-4.276.703.711-4.304,4.259c.186.304.299.657.299,1.039,0,1.103-.897,2-2,2Zm0-1c.552,0,1-.449,1-1s-.448-1-1-1-1,.449-1,1,.448,1,1,1Zm6.383-3.859c.393.874.617,1.84.617,2.859h1c0-1.296-.317-2.517-.866-3.601l-.751.743Zm2.617,10.77c1.861-2.115,3-4.879,3-7.911C24,5.383,18.617,0,12,0S0,5.383,0,12c0,3.032,1.139,5.796,3,7.911v-1.598c-1.256-1.788-2-3.962-2-6.313C1,5.935,5.935,1,12,1s11,4.935,11,11c0,2.351-.744,4.525-2,6.313v1.598Zm-3,4.089h1v-8h-1v8Zm-1.5-5.5c0,1.381-1.119,2.5-2.5,2.5h-1.5v3h-1v-8h2.5c1.381,0,2.5,1.119,2.5,2.5Zm-1,0c0-.827-.673-1.5-1.5-1.5h-1.5v3h1.5c.827,0,1.5-.673,1.5-1.5Zm-5-2.5h-1.053l-1.947,3.5h-1.5v-3.5h-1v8h1v-3.5h1.947l1.566,3.5h1.05l-1.997-4.565,1.934-3.435Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometerKpi);
export default __webpack_public_path__ + "static/media/speedometer-kpi.9705ea3d5d2cd42de311b66988241b7b.svg";
export { ForwardRef as ReactComponent };